import { render } from "./CreatePackForm.vue?vue&type=template&id=20cafc5c"
import script from "./CreatePackForm.vue?vue&type=script&lang=js"
export * from "./CreatePackForm.vue?vue&type=script&lang=js"

import "./CreatePackForm.vue?vue&type=style&index=0&id=20cafc5c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__